module.exports = __webpack_public_path__ + "img/01.17e6c0e6.png";